export const LICENSES = 'LICENSES';
export type LICENSES = typeof LICENSES;

export const LICENSES_SUCCESS = 'LICENSES_SUCCESS';
export type LICENSES_SUCCESS = typeof LICENSES_SUCCESS;

export const LICENSES_FAILED = 'LICENSES_FAILED';
export type LICENSES_FAILED = typeof LICENSES_FAILED;

export const LICENSE_DETAIL = 'LICENSE_DETAIL';
export type LICENSE_DETAIL = typeof LICENSE_DETAIL;

export const LICENSE_DETAIL_FAILED = 'LICENSE_DETAIL_FAILED';
export type LICENSE_DETAIL_FAILED = typeof LICENSE_DETAIL_FAILED;

export const LICENSE_DETAIL_SUCCESS = 'LICENSE_DETAIL_SUCCESS';
export type LICENSE_DETAIL_SUCCESS = typeof LICENSE_DETAIL_SUCCESS;

export const LICENSE_SYNC_USAGE = 'LICENSE_SYNC_USAGE';
export type LICENSE_SYNC_USAGE = typeof LICENSE_SYNC_USAGE;

export const LICENSE_SYNC_USAGE_SUCCESS = 'LICENSE_SYNC_USAGE_SUCCESS';
export type LICENSE_SYNC_USAGE_SUCCESS = typeof LICENSE_SYNC_USAGE_SUCCESS;

export const LICENSE_SYNC_USAGE_FAILED = 'LICENSE_SYNC_USAGE_FAILED';
export type LICENSE_SYNC_USAGE_FAILED = typeof LICENSE_SYNC_USAGE_FAILED;

export const LICENSE_REFERENCES = 'LICENSE_REFERENCES';
export type LICENSE_REFERENCES = typeof LICENSE_REFERENCES;

export const LICENSE_REFERENCES_SUCCESS = 'LICENSE_REFERENCES_SUCCESS';
export type LICENSE_REFERENCES_SUCCESS = typeof LICENSE_REFERENCES_SUCCESS;

export const LICENSE_REFERENCES_FAILED = 'LICENSE_REFERENCES_FAILED';
export type LICENSE_REFERENCES_FAILED = typeof LICENSE_REFERENCES_FAILED;
